module.exports = __webpack_public_path__ + "static/media/frankKids79.1c510470.png";